import { FC, useContext, useMemo } from "react";

import appStyles from "../../../App.module.css";
import { BusinessTravelContext } from "../../BusinessTravel";
import {
  businessTravelDocs,
  businessTravelEUDocs,
  businessTravelUKDocs,
  showPartnerLogoAndText,
  showPartnerLogoAndTextNote,
} from "../../config/bt-constants";
import { IBusinessTravelContext } from "../../config/interfaces";

interface FooterProps {}

const Footer: FC<FooterProps> = (props: FooterProps) => {
  const { version, currentStep, quoteData } = useContext(BusinessTravelContext) as IBusinessTravelContext;

  const hidePartnerText = useMemo(() => {
    return showPartnerLogoAndText(quoteData?.affiliateId, version);
  }, [version, quoteData?.affiliateId]);

  return (
    <div className={`${appStyles.footerContentWrapper} ${appStyles.btFooterContentWrapper}`}>
      {(currentStep === 0 || currentStep === 1) && hidePartnerText ? (
        <p>
          Please note that before acceding to these services, you will need to review and accept battleface T&Cs.
          Bedsonline assumes no responsibility for the services provided by battleface.
        </p>
      ) : null}

      {currentStep !== 3 && (
        <div className={appStyles.btFooterLinkWrap}>
          <span>By continuing, you agree to our </span>
          <a
            className={appStyles.btFooterLink}
            href={version === "UK" ? businessTravelUKDocs.privacyPolicy : businessTravelEUDocs.privacyPolicy}
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
          ,&nbsp;
          <a
            className={appStyles.btFooterLink}
            href={version === "UK" ? businessTravelUKDocs.termsAndConditions : businessTravelEUDocs.termsAndConditions}
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms & Conditions
          </a>
          , and&nbsp;
          <a
            href={version === "UK" ? businessTravelUKDocs.cookiePolicy : businessTravelEUDocs.cookiePolicy}
            className={appStyles.btFooterLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            Cookie Policy.
          </a>
        </div>
      )}
      {currentStep !== 0 && (
        <div className={appStyles.mB24}>
          <p className={appStyles.btDestinationsInfoHeading}>Maximum Trip duration 31 days</p>
          <b>This policy covers trips on a worldwide basis except for travel to the following destinations:</b>
          &nbsp;{businessTravelDocs.excludedDestinations}
        </div>
      )}

      {version === "UK" ? (
        <p>
          <b>Important Note:</b>&nbsp;
          {showPartnerLogoAndTextNote.includes(quoteData.affiliateId)
            ? "Bedsonline is a brand of Hotelbeds UK Ltd, who are an Introducer Appointed Representative of battleface Insurance Services Limited. battleface Insurance Services Ltd. is authorised and regulated by the Financial Conduct Authority in the UK (FRN 774757). Their registered address is Suite 102, 80 Churchill Square, Kings Hill, West Malling, Kent, ME19 4YU, UK. battleface insurance product is placed with certain underwriters at Lloyd's of London."
            : businessTravelDocs.importantNote ||
              `battleface Insurance Services Ltd. is authorised and regulated by the Financial Conduct
          Authority in the UK (registration number 774757 ). Their registered address is Suite 24, 80 Churchill Square,
          Kings Hill, West Malling, Kent, ME19 4YU, UK. battleface insurance product is placed with certain underwriters
          at Lloyd’s of London.`}
        </p>
      ) : (
        <p>
          <b>Important Note:</b>&nbsp;
          {businessTravelDocs.importantNote ||
            `battleface Underwriting Services SRL (battleface) is authorised and regulated by the Financial Services and Markets Authority in Belgium (registered number BCE.0744.970.292). Their registered address is Avenue Des Arts 6-9, 1210 Saint-Josse-Ten-Noode, Brussels, Belgium. battleface acts as an agent of Hamilton Insurance DAC. in performing its duties under the Coverholder Appointment Agreement.`}
        </p>
      )}
    </div>
  );
};

export default Footer;
